import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FilterSelect from '../components/common/FilterSelect';
import FederationCard from '../components/common/FederationCard';

const provincialFeds = [
  { name: 'Federazione Roma', territory: 'Lazio', description: "La federazione più grande d'Italia. Coordina oltre 40 circoli nella Capitale.", circles: 40, members: '800+', type: 'provinciale' },
  { name: 'Federazione Milano', territory: 'Lombardia', description: "La federazione milanese coordina il lavoro dei GD nell'area metropolitana.", circles: 35, members: '650+', type: 'provinciale' },
  { name: 'Federazione Firenze', territory: 'Toscana', description: 'Federazione storica dei GD toscani. Formazione, cultura e partecipazione.', circles: 18, members: '380+', type: 'provinciale' },
  { name: 'Federazione Napoli', territory: 'Campania', description: "Federazione partenopea. Lavoro, periferie e legalità al centro dell'azione.", circles: 22, members: '420+', type: 'provinciale' },
  { name: 'Federazione Torino', territory: 'Piemonte', description: 'Federazione torinese. Innovazione, integrazione e diritti al lavoro.', circles: 15, members: '310+', type: 'provinciale' },
  { name: 'Federazione Bologna', territory: 'Emilia-Romagna', description: 'Federazione bolognese. Ambiente, università e partecipazione giovanile.', circles: 12, members: '280+', type: 'provinciale' },
  { name: 'Federazione Palermo', territory: 'Sicilia', description: 'Federazione palermitana. Legalità, lavoro e futuro delle nuove generazioni.', circles: 8, members: '150+', type: 'provinciale' },
  { name: 'Federazione Bari', territory: 'Puglia', description: 'Federazione barese. Scuola, periferie e valorizzazione del territorio.', circles: 10, members: '200+', type: 'provinciale' },
  { name: 'Federazione Venezia', territory: 'Veneto', description: 'Federazione veneziana. Ambiente, turismo sostenibile e accessibilità.', circles: 7, members: '130+', type: 'provinciale' },
];

const FederazioniPage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredFeds = provincialFeds.filter(f => 
    f.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
    f.territory.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Federazioni Provinciali' }];

  return (
    <Layout>
      <HeroPage 
        breadcrumbs={breadcrumbs} 
        overline="Territorio" 
        title="Federazioni Provinciali" 
        subtitle="Le 107 federazioni provinciali dei Giovani Democratici coordinano il lavoro dei circoli e la presenza capillare sul territorio." 
      />
      
      <section className="section section--sm">
        <div className="container">
          <Toolbar className="mb-6"
            left={<SearchBar placeholder="Cerca federazione..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />}
            right={<FilterSelect label="Regione" options={['Tutte', 'Lombardia', 'Lazio', 'Toscana', 'Campania', 'Sicilia', 'Puglia', 'Veneto', 'Piemonte', 'Emilia-Romagna']} />}
          />

          <div className="results-count mb-6">
            Trovate <strong>{filteredFeds.length}</strong> federazioni provinciali
          </div>

          <div className="grid grid-3">
            {filteredFeds.map((f) => (
              <FederationCard key={f.name} {...f} />
            ))}
          </div>

          {filteredFeds.length === 0 && (
            <div className="text-center py-20">
              <p className="text-secondary">Nessuna federazione trovata con questi criteri.</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default FederazioniPage;
